import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React, { useEffect, useId, useState } from 'react';
import { Input } from './ui/input';
export default function DatabaseLocationInput({
  kind,
  ...props
}) {
  __useLocale();
  const id = useId();
  const [options, setOptions] = useState([]);
  const [error, setError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    const url = kind === 'city' ? '/api/cities.php?type=hotel' : `/api/countries.php?type=${kind === 'visa' ? 'visa' : 'country'}`;
    fetch(url, {
      signal: controller.signal
    }).then(async res => {
      if (!res.ok) throw new Error();
      const rows = await res.json();
      if (!Array.isArray(rows)) throw new Error();
      setOptions(rows);
    }).catch(() => {
      if (!controller.signal.aborted) setError(true);
    });
    return () => controller.abort();
  }, [kind]);
  return <><select {...props} aria-label={__tr(props.placeholder)} className="block w-full border rounded-lg p-2 bg-white"><option value="">{__tr(props.placeholder || "اختر")}</option>{__tr(props.value && !options.some(o => o.name === props.value) && <option value={props.value}>{__tr(props.value)}</option>)}{__tr(options.map(o => <option key={o.id} value={o.name}>{__tr(__localizedField(o, "name"))}</option>))}</select>{__tr(error && <span className="text-xs text-red-700">{__tr("تعذر تحميل القائمة من القاعدة")}</span>)}{__tr(!error && !options.length && <small>{__tr("أضف الخيارات من قائمة الدول والمواقع.")}</small>)}</>;
}
